import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSDataGridCollapsable, {
  IColumnsCollapsable
} from "../../Components/DataGrid/WSDataGridCollapsable";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";

export const ProductServiceMappingList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view } = getPermissions(
    MasterPages.AddOnService,
    IRoleMain.Masters
  );
  const [serviceProductList, setServiceProductList] = useState<any>([]);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [reload, setReload] = useState(false);
  const [totalCount, setTotalCount] = useState<any>();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  //   useEffect(() => {
  //     async function getMappedServiceProducts() {
  //       const response: any = await callAPI(
  //         "Mapping/service-to-products",
  //         Method.GET
  //       );
  //       const serveceProductArr: Array<any> = [];
  //       if (response) {
  //         // response.data.map((item: any) => {
  //         //     serveceProductArr.push({
  //         //         productName: item?.productName,
  //         //         subRows: item.services?.map((service: any) => ({
  //         //             ...service,
  //         //             productId: item?.id
  //         //         }))
  //         //     })
  //         // })
  //         setServiceProductList(response || []);
  //         setTotalCount(response?.length);
  //       }
  //     }
  //     getMappedServiceProducts();
  //   }, []);
  useEffect(() => {
    async function getMappedServiceProducts() {
      const response: any = await callAPI(
        "Mapping/products-with-services",
        Method.GET
      );

      if (response) {
        // Filter only those with isWeightBased === true
        const filteredProducts = response.filter((product: any) =>
          product.services?.some(
            (service: any) => service.isWeightBased === true
          )
        );

        setServiceProductList(filteredProducts || []);
        setTotalCount(filteredProducts?.length);
      }
    }
    getMappedServiceProducts();
    setReload(false);
  }, [reload]);
  const source = {
    url: "Mapping/service-to-products",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  const handleActions = async (action: any, row: any) => {
    if (action === "Delink") {
      const response: any = await delinkService(row);
    }
  };
  const delinkService = async (row: any) => {
    try {
      const response = await callAPI(
        `laundry-service-products/${row?.productId}/unlink/${row?.id}`,
        Method.DELETE
      );
      if (response && response?.success) {
        showMessage(
          response?.message || "Service delink done successfully",
          "success"
        );
        setReload(true);
      }
    } catch (e) {
      showMessage("Something went wrong", "error");
    }
  };

  // const columns: IColumnsCollapsable[] = [
  //     {
  //         header: "Product Name",
  //         fieldName: "productName",
  //         tooltip: true,
  //         subColumns: {
  //             data: [{
  //                 header: "Service",
  //                 fieldName: "serviceName",
  //                 tooltip: true
  //             },
  //             {
  //                 header: "Base",
  //                 fieldName: "basePrice",

  //             },
  //             {
  //                 header: "Base Price",
  //                 fieldName: "basePrice",

  //             },
  //             {
  //                 header: "Weight Price",
  //                 fieldName: "weightPrice",

  //                 type: "default"
  //             },
  //             {
  //                 header: "Urgent Service Price",
  //                 fieldName: "urgentServicePrice",

  //             }],
  //             action: {
  //                 header: "Actions",
  //                 fieldName: "actions",
  //                 type: "action",
  //                 // actions: ["Delink"],
  //                 actions: edit ? ["Delink"] : undefined,
  //                 actionCallback: (action: any, row: any) => handleActions(action, row)
  //             }
  //         },

  //     }

  //     // {
  //     //     header: "Actions",
  //     //     fieldName: "actions",
  //     //     type: "action",
  //     //     actions: ["Delink"],
  //     //     actionCallback: (action, row) => handleActions(action, row)
  //     // }
  // ];

  const columns: IColumns[] = [
    {
      header: "Image",
      fieldName: "imageUrl",
      type: "img"
    },

    {
      header: "Product",
      fieldName: "productName",
      type: "default"
    },

    {
      header: "Product Type",
      fieldName: "productType",
      type: "default"
    },

    // {
    //   header: "Total Services",
    //   fieldName: "weightPrice",
    //   type: "default"
    // },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const handleAction = (action: string, row: any) => {
    if (action === "Delete") {
      setSelectedId(row?.id);
      setPopupOpen(true);
    }
  };
  const handleClick = () => {
    navigate("/product-service-map");
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("serviceGrid"));
    showMessage("Service removed successfully!", "success");
  };
  return (
    <>
      <HeaderList
        title="Product to Service Mapping"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />

      {view ? (
        <Grid item xs={12}>
          <WSDataGrid
            id="serviceGrid"
            title="Services"
            columns={columns}
            headerType="HaderTopCornered"
            //  source={source}
            data={serviceProductList}
            // exportCsv={exports}
            addButton={add ? { label: "", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            //transFormData={transFormData}
          />
        </Grid>
      ) : (
        <PermissionDenied />
      )}
      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"Brand/delete"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this item?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
});
